import { Entity } from '@nx-smartmonkey/shared/domain';
import { EventType } from './EventType';

export interface WebhookProps {
  enabled: boolean;
  enabled_events: EventType[];
  created_by: string;
  url: string;
  organization_id: string;
  project_id: string;
  created_at?: Date;
  deleted_at?: Date;
  updated_at?: Date;
  failure_count: number;
  api_version: number;
}

export class Webhook extends Entity<WebhookProps> {
  private constructor(props: WebhookProps, id?: string) {
    super(props, id);
  }

  static create(props: WebhookProps, id?: string) {
    const expression1 =
      /(https:\/\/|http:\/\/)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi;
    const regex1 = new RegExp(expression1);
    if (!props.url || !props.url.match(regex1)) {
      throw new Error(`Cannot create webhook: Invalid url`);
    }
    if (!props.enabled_events || props.enabled_events.length === 0) {
      throw new Error(`Cannot create webhook: No enabled events`);
    }
    return new Webhook(props, id);
  }

  get id(): string {
    return this._id!;
  }

  get enabled(): boolean {
    return this.props.enabled;
  }

  set enabled(enabled: boolean) {
    this.props.enabled = enabled;
  }

  get enabled_events(): EventType[] {
    return this.props.enabled_events;
  }

  set enabled_events(enabled_events: EventType[]) {
    this.props.enabled_events = enabled_events;
  }

  get created_by(): string {
    return this.props.created_by;
  }

  get url(): string {
    return this.props.url;
  }

  set url(url: string) {
    this.props.url = url;
  }

  get organization_id(): string {
    return this.props.organization_id;
  }

  get project_id(): string {
    return this.props.project_id;
  }

  get created_at(): Date | undefined {
    return this.props.created_at;
  }

  get deleted_at(): Date | undefined {
    return this.props.deleted_at;
  }

  get updated_at(): Date | undefined {
    return this.props.updated_at;
  }

  get failure_count(): number {
    return this.props.failure_count;
  }

  get api_version(): number {
    return this.props.api_version;
  }
}
